import { format, isValid, parseISO } from 'date-fns';
import { formatInTimeZone, fromZonedTime, toZonedTime } from 'date-fns-tz';

import { getLocalTimeZone } from './date';

/**
 * Localize the given UTC date to an ISO string in the local timezone.
 *
 * @param {string} date - The input ISO UTC date string.
 * @returns {string} - The ISO string in local time (e.g., '2024-08-20T09:56:59.287').
 */
export const convertUTCToLocal = (date: string): string => {
  if (!date) {
    return '';
  }

  // Ensure UTC
  const utcDate = parseISO(date.endsWith('Z') ? date : `${date}Z`);

  if (!isValid(utcDate)) {
    return '';
  }

  const localTimezone = getLocalTimeZone();

  const zonedDate = toZonedTime(utcDate, localTimezone);

  return format(zonedDate, "yyyy-MM-dd'T'HH:mm:ss.SSS");
};

/**
 * Convert a local timezone date to a UTC ISO string.
 *
 * @param {string} date - The input ISO local date string (no timezone).
 * @returns {string} - The ISO string in UTC (e.g., '2024-08-20T06:56:59.287Z').
 */
export const convertLocalToUTC = (date: string): string => {
  if (!date) {
    return '';
  }

  const localTimezone = getLocalTimeZone();

  const utcDate = fromZonedTime(date, localTimezone);

  return isValid(utcDate) ? formatInTimeZone(utcDate, 'UTC', "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'") : '';
};
